/* eslint-disable react/display-name */
import React, { forwardRef } from 'react';
import useDialogsContainer from '@/hooks/util/useDialogContainer';
import type {
  DialogContent,
  IAlertDialogProps,
  IConfirmationDialogProps,
} from '@/infra/dialog/DialogEventManager';
import { DialogTypes } from '@/infra/dialog/DialogEventManager';
import Alert from '../alert/Alert';
import Confirmation from '../confirmation/Confirmation';

export const DialogContainer = forwardRef<
  HTMLDivElement,
  { className?: string; style?: React.CSSProperties }
>(props => {
  const { getDialogsOpened, isDialogActived } = useDialogsContainer();
  const { className, style } = props;

  const dialogsList = getDialogsOpened();

  const containerStyle: React.CSSProperties = !dialogsList.length
    ? { ...style, pointerEvents: 'none' }
    : { ...style };

  function renderAlert(content: DialogContent, props: IAlertDialogProps) {
    const {
      dialogId,
      onConfirm,
      confirmText,
      isAlert,
      closeIcon,
      closeOnDimerClick,
    } = props;

    return (
      <Alert
        key={`confirmation-${dialogId}`}
        onConfirm={onConfirm}
        open={isDialogActived(dialogId)}
        closeIcon={closeIcon}
        isAlert={isAlert}
        confirmText={confirmText}
        closeOnDimerClick={closeOnDimerClick}
      >
        {content || (
          <p>
            <b>A ação ocorreu com sucesso!</b>
          </p>
        )}
      </Alert>
    );
  }

  function renderConfirmation(
    content: DialogContent,
    props: IConfirmationDialogProps,
  ) {
    const {
      dialogId,
      onConfirm,
      onRefuse,
      acceptText,
      isAlert,
      closeIcon,
      refuseText,
      closeOnDimerClick,
    } = props;

    return (
      <Confirmation
        key={`confirmation-${dialogId}`}
        onConfirm={onConfirm}
        onRefuse={onRefuse}
        open={isDialogActived(dialogId)}
        closeIcon={closeIcon}
        isAlert={isAlert}
        acceptText={acceptText}
        refuseText={refuseText}
        closeOnDimerClick={closeOnDimerClick}
      >
        {content || (
          <p>
            <b> Você realmente deseja continuar com a ação?</b>
          </p>
        )}
      </Confirmation>
    );
  }

  return (
    <div>
      <div className={className} style={containerStyle}>
        {dialogsList.map(dialog => {
          switch (dialog.type) {
            case DialogTypes.Confirmation:
              return renderConfirmation(
                dialog.content,
                dialog.props as IConfirmationDialogProps,
              );
            case DialogTypes.Alert:
              return renderAlert(
                dialog.content,
                dialog.props as IAlertDialogProps,
              );
            default:
              return null;
          }
        })}
      </div>
    </div>
  );
});
